/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpsertSystemSipTrunksResult } from '../../models/upsert-system-sip-trunks-result';

export interface ApiAdminLivekitSipSystemTrunksPost$Params {
  recreate?: boolean;
}

export function apiAdminLivekitSipSystemTrunksPost(http: HttpClient, rootUrl: string, params?: ApiAdminLivekitSipSystemTrunksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpsertSystemSipTrunksResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminLivekitSipSystemTrunksPost.PATH, 'post');
  if (params) {
    rb.query('recreate', params.recreate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpsertSystemSipTrunksResult>;
    })
  );
}

apiAdminLivekitSipSystemTrunksPost.PATH = '/api/Admin/livekit/sip/system-trunks';
